// Builds a tailored-audit record for a non-task subject (the introduction or its notes). Mirrors
// formatCreateTailoredAudit but keys by a synthetic subject id (e.g. "intro" / "introNote") and carries
// no value diff — the audit exists to hold the justification reason. Empty `originalValues`/
// `tailoredValues` pass the server's key whitelist (checkTailoringAuditKeys) unchanged, so this needs no
// schema change and never collides with real task audits.
export function formatCreateSubjectAudit({
    subjectId,
    subjectTitle,
    tailoringReferenceId,
    schedule,
    scheduleItem,
    reason,
}) {
    return {
        referenceId: `${tailoringReferenceId}.${subjectId}`,
        reason,
        scheduleId: schedule?.id,
        scheduleVersion: scheduleItem?.version,
        scheduleTitle: schedule?.title,
        scheduleCode: scheduleItem?.code,
        taskId: subjectId,
        taskTitle: subjectTitle,
        originalValues: {},
        tailoredValues: {},
    }
}
